import React, { useEffect } from "react";
import { Link } from 'react-router-dom';
import './Home.css';

const Home = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to the top-left corner
  }, []); // Empty dependency array ensures it runs only once on mount
  
  return (
    <div className="home-page">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-content">
          <h1>Welcome to <br></br>Zenith World Wide Company</h1>
          <p>Leading the future of innovation and excellence</p>
          <Link to="/services" className="cta-button">Explore Our Services</Link>
        </div>
      </section>

      {/* About Us Section */}
      <section className="about-section">
        <div className="container">
          <h2>About Us</h2>
          
          {/* Logo Watermark */}
          <div className="logo-watermark">
            <img src="/logo.png" alt="Zenith World Wide Logo" className="watermark-logo" />
          </div>
          
          <div className="about-content">
            <p>Zenith World Wide is a leading company dedicated to delivering exceptional products and services that drive innovation and excellence across various industries.</p>
            <p>With years of experience and a commitment to quality, we have established ourselves as a trusted partner for businesses worldwide.</p>
            <p>Our team of experts works tirelessly to provide cutting-edge solutions that meet the evolving needs of our clients and partners.</p>
            <p>We believe in building lasting relationships through transparency, integrity, and continuous improvement in everything we do.</p>
            <Link to="/about" className="read-more-link">Read More</Link>
          </div>
        </div>
      </section>

      {/* Products and Services Section */}
      <section className="services-section">
        <div className="container">
          <h2>Our Products and Services</h2>
          <div className="services-grid">
            <div className="service-card">
              <h3>Contracting & Construction</h3>
              <p>We provide complete contracting and construction solutions with a focus on quality, safety, and timely delivery. Our team manages projects from start to finish — including planning, design, approvals, and execution. Whether it’s residential, commercial, or industrial projects, we ensure strong foundations, reliable structures, and cost-effective solutions. Our goal is to deliver projects that meet client expectations and add long-term value.</p>
            </div>
            <div className="service-card">
              <h3>Manpower Services</h3>
              <p>We provide skilled and unskilled manpower to meet the needs of different industries. Our recruitment process ensures that every worker is trained, reliable, and ready to deliver quality work. From construction labor and technical staff to administrative and support teams, we supply manpower that helps businesses run smoothly and efficiently.</p>
            </div>
            <div className="service-card">
              <h3>IT & Digital Solutions</h3>
              <p>We deliver innovative IT and digital solutions to help businesses stay ahead in today’s fast-changing world. Our services include software development, web and mobile applications, digital marketing, cloud With a focus on reliability and performance, we create technology that makes work easier, faster, and more efficient — helping our clients grow and succeed in the digital era.solutions, and IT support.</p>
            </div>
            <div className="service-card">
              <h3>General Services</h3>
              <p>We provide a wide range of general services designed to support individuals and businesses in their day-to-day needs. From facility management and maintenance to logistics, cleaning, and administrative support, our team ensures reliable, cost-effective, and timely service delivery.Our focus is on convenience, quality, and customer satisfaction, making us a trusted partner for all your service requirements.</p>
            </div>
            <div className="service-card">
              <h3>Products</h3>
              <h4>
                <p>
                  <ul>
                    <p>Building Materials</p>
                    <p>Oil & Gas Spare parts</p>
                    <p>IT Hardware</p>
                    <p>General Products</p>
                  </ul>
                </p>
              </h4>
            </div>
          </div>
          <Link to="/services" className="cta-button">View All Services</Link>
        </div>
      </section>

      {/* Latest News Section */}
      {/*
      <section className="news-section">
        <div className="container">
          <h2>Latest Company News</h2>
          <div className="news-preview">
            <div className="news-item">
              <h3>Zenith World Wide Expands Global Operations</h3>
              <p>We're excited to announce the opening of new offices in key markets worldwide...</p>
            </div>
            <div className="news-item">
              <h3>New Product Launch: Innovation Series 2024</h3>
              <p>Introducing our latest line of innovative products designed to revolutionize...</p>
            </div>
          </div>
          <Link to="/news" className="cta-button">Read All News</Link>
        </div>
      </section>
      */}
    </div>
  );
};

export default Home;
